module.exports = __webpack_public_path__ + "img/other.c1cb4cb0.svg";